import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalService } from '../../../../core/modal/modal.service';
import { ModuleModalComponent } from '../../../../shared/components/modals/modules/modules.component';
import { UserPermissionsService } from '../../user-permissions.service';
import { Permission } from '../../../../core/modules/admin/admin.types';

@UntilDestroy()
@Component({
  selector: 'tax-user-permissions',
  templateUrl: 'user-permissions.component.html',
  styleUrls: ['../user.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class UserPermissionsComponent {
  @Input() selectedPermissions: Permission[] = [];

  @Output() selectedPermissionsChanged = new EventEmitter<Permission[]>();

  constructor(
    private cdr: ChangeDetectorRef,
    private modalService: ModalService,
    private userPermissionsService: UserPermissionsService,
  ) {
  }

  getDisplayedSelectedPermissions(selectedPermissions: Permission[]): Permission[] {
    return this.userPermissionsService.getDisplayedSelectedPermissions(selectedPermissions);
  }

  permissionsTrackBy(index: number, item: Permission): string {
    return item;
  }

  selectPermissions(): void {
    this.modalService.openOld<Permission[]>(ModuleModalComponent, {
      selectedPermissions: this.selectedPermissions,
    }, {
      width: '740px',
    })
      .pipe(untilDestroyed(this))
      .subscribe((selectedPermissions) => {
        this.selectedPermissions = selectedPermissions;
        this.cdr.detectChanges();
        this.selectedPermissionsChanged.emit(selectedPermissions);
      });
  }
}
